import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
          // Select displayed value area: 80% white background (rgba) so text/icons stay fully opaque
          '& .MuiSelect-select': {
            backgroundColor: 'rgba(255,255,255,0.5)',
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: alpha(theme.palette.grey[500], 0.56),
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          // Make filled inputs (and Selects that use the filled variant) less transparent
          // Increased alpha values to reduce transparency and improve readability
          backgroundColor: alpha(theme.palette.grey[500], 0.52),
          '&:hover': {
            backgroundColor: alpha(theme.palette.grey[500], 0.58),
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.focus,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          '&:before': {
            borderBottomColor: alpha(theme.palette.grey[500], 0.56),
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.grey[500], 0.32),
          },
          // Ensure Selects inside outlined inputs use 80% white background
          '& .MuiSelect-select': {
            backgroundColor: 'rgba(255,255,255,0.8)',
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: 'rgba(255,255,255,0.5)',
          '&:focus': {
            backgroundColor: 'rgba(255,255,255,0.5)',
          },
        },
        root: {
          backgroundColor: 'rgba(255,255,255,0.5)',
        },
      },
    },
  };
}
